import React, { useEffect, useRef } from "react";
import { Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { useRccTypography } from "./typography";
import { rccColors } from "./colors";
import { appService } from "../App/app.service";

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "2px",
    flex: "1 0 0",
  },
}));

function RccHeader() {
  const classes = useStyles();
  const typography = useRccTypography();
  const dispatch = useDispatch();
  const fetchingRef = useRef(false);
  const user = useSelector((state) => state.app?.user);
  const homepageData = useSelector((state) => state.app?.homepageData);
  const homepageDataRows = homepageData?.data || homepageData;
  const roleInfo = homepageDataRows?.[4]?.[0];
  const roleType = roleInfo?.Role_Type;
  const teamName = roleInfo?.Team;

  // Use firstName only
  const userName = user?.firstName || "User";

  // Use Value_Label as company name if available, fallback to default
  const companyName = user?.companyName || "Company";
  const isAdmin = roleType === "admin" || roleType === "c-level";
  const isManager = roleType === "manager";
  const headerSubject = isAdmin ? companyName : isManager ? teamName : "";
  const isLoading = homepageData === "";

  useEffect(() => {
    if (homepageData === "" && !fetchingRef.current) {
      fetchingRef.current = true;
      dispatch({ type: "get_homepage_data_request" });
      appService.homepageData().then(
        (resp) => {
          fetchingRef.current = false;
          dispatch({
            type: "get_homepage_data_success",
            homepageData: {
              data: resp.message.recordsets,
              columns: resp.message.columns,
              quartersToUse: resp.message.quartersToUse,
              differentQtrData: resp.message.differentQtrData,
            },
          });
        },
        (err) => {
          fetchingRef.current = false;
          dispatch({ type: "get_homepage_data_failure", error: err });
        }
      );
    }
  }, [homepageData, dispatch]);

  if (isLoading) {
    return (
      <Box className={classes.header}>
        <Skeleton variant="text" width={180} height={30} animation="wave" />
        <Skeleton variant="text" width={240} height={20} animation="wave" />
      </Box>
    );
  }

  return (
    <Box className={classes.header}>
      <Typography
        className={typography.displaySmallSemibold}
        style={{ color: rccColors.neutral[900] }}
      >
        Hello {userName}
      </Typography>
      <Typography
        className={typography.textMediumRegular}
        style={{ color: rccColors.neutral[500] }}
      >
        {headerSubject
          ? `Here's how ${headerSubject} is doing`
          : "Here's how you're doing"}
      </Typography>
    </Box>
  );
}

export default RccHeader;
